import { versionToNumber } from 'minecraft-renderer/src/lib/utils';
export default () => {
    let i = 0;
    bot.pingProxy = async () => {
        const curI = ++i;
        return new Promise(resolve => {
            //@ts-expect-error
            bot._client.socket._ws.send(`ping:${curI}`);
            const date = Date.now();
            const onPong = (received) => {
                if (received !== curI.toString())
                    return;
                bot._client.socket.off('pong', onPong);
                resolve(Date.now() - date);
            };
            bot._client.socket.on('pong', onPong);
        });
    };
    let pingId = 0;
    bot.pingServer = async () => {
        if (versionToNumber(bot.version) < versionToNumber('1.20.2'))
            return bot.player?.ping ?? -1;
        return new Promise((resolve) => {
            const curId = pingId++;
            bot._client.write('ping_request', { id: BigInt(curId) });
            const date = Date.now();
            const onPong = (data) => {
                if (BigInt(data.id) !== BigInt(curId))
                    return;
                bot._client.off('ping_response', onPong);
                resolve(Date.now() - date);
            };
            bot._client.on('ping_response', onPong);
        });
    };
};
